var _defs, _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "box-bottom-right_svg__box-bottom-right",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 302.6 302.59"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "box-bottom-right_svg__clip-path",
    transform: "translate(-2.53 -2.08)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-19.51-26.26h327.79v359.28H-19.51z"
  })), /*#__PURE__*/React.createElement("style", null, ".box-bottom-right_svg__cls-5{fill:none}.box-bottom-right_svg__cls-4{fill:#fff}.box-bottom-right_svg__cls-5{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3.15px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#box-bottom-right_svg__clip-path)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    className: "box-bottom-right_svg__cls-4",
    width: 302.6,
    height: 302.59,
    rx: 33.47
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "box-bottom-right_svg__cls-4",
    d: "M152.21 46.44h5.8v196.64h-5.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "box-bottom-right_svg__cls-5",
    d: "M152.21 46.44h5.8v196.64h-5.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "box-bottom-right_svg__cls-4",
    d: "M56.79 141.87h196.64v5.8H56.79z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "box-bottom-right_svg__cls-5",
    d: "M56.79 141.87h196.64v5.8H56.79z"
  })));
}
export default __webpack_public_path__ + "3424cd316508496c3a43cf31809323aa.svg";
export { SvgBoxBottomRight as ReactComponent };